import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionLimitModal = ({ isOpen, onClose, currentPlan = 'free' }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/billing-dashboard');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-2xl w-full max-w-md">
        <div className="p-6 md:p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-warning/10 flex items-center justify-center">
            <Icon name="Lock" size={32} className="text-warning" />
          </div>

          <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
            Upgrade to Add More Offers
          </h2>

          <p className="text-sm md:text-base text-muted-foreground mb-2">
            You've reached the limit of 2 offers on the Free plan. Upgrade to Pro for unlimited offers and access to AI-powered insights.
          </p>
          
          <p className="text-sm text-primary font-medium mb-6">
            Pro plans start at just $15/month or save 17% with $150/year.
          </p>

          <div className="bg-muted rounded-lg p-4 mb-6 text-left">
            <h3 className="text-sm font-semibold text-foreground mb-3">Pro Plan Benefits:</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                <span>Unlimited properties and offers</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                <span>AI-powered offer summaries</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                <span>Key difference highlighting</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                <span>Professional PDF reports</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                <span>Automatic email delivery</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="ghost"
              onClick={onClose}
              fullWidth
            >
              Maybe Later
            </Button>
            <Button
              variant="default"
              onClick={handleUpgrade}
              iconName="Crown"
              iconPosition="left"
              fullWidth
            >
              Upgrade to Pro
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionLimitModal;